import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { LOCAL_STORAGE_CONSTANT, TEXT_CONSTANT } from '../../../constants/app';
import { APP_ROUTES } from '../../../route';
import { extractJSON } from '../../../services/jsonUtil';

import './style.css';

const Header = props => {
  const user = extractJSON(LOCAL_STORAGE_CONSTANT.USER);
  const buttonTitle = user ? TEXT_CONSTANT.JOIN_NOW : TEXT_CONSTANT.LOGIN;
  const handleRedirection = () => props.history.push(APP_ROUTES.ROOT);
  return (
    <div className="grateful-header header-wrapper d-flex justify-content-between px-lg-5 px-md-3 align-items-center">
      <div className="logo" onClick={handleRedirection}>
        <h2 className="logo-text">Jen</h2>
      </div>
      <div>
        <button
          className="join border px-3"
          onClick={() =>
            props.onClick(
              TEXT_CONSTANT.ENROLL_NOW,
              'isLogin',
              'navigation header',
            )
          }
        >
          {TEXT_CONSTANT.ENROLL_NOW}
        </button>
        <button
          className="join"
          onClick={() =>
            props.onClick(buttonTitle, 'isLogin', 'navigation header')
          }
        >
          {buttonTitle}
        </button>
      </div>
    </div>
  );
};

Header.propTypes = {
  history: PropTypes.object,
  onClick: PropTypes.func,
};

export default withRouter(Header);
